/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Formio } from '@formio/angular';
import { environment } from '@environment';
import { AppModule } from './app/app.module';

/**
 * Point the Form.io renderer at our own deployment, BEFORE anything renders.
 *
 * These are statics read when a Formio instance is constructed, so a component that rendered first
 * would keep whatever was in force then -- which is why this sits ahead of bootstrapModule rather
 * than in a module constructor or an APP_INITIALIZER.
 *
 * Leaving them unset is not neutral: @formio/js ships `baseUrl = 'https://api.form.io'`, so an
 * unconfigured renderer aims at Form.io's PUBLIC SaaS. File upload is where that surfaces, because
 * it is the one component that calls back to the server -- the SDK posts to
 * `${formio.formUrl}/storage/s3`, and with no project set `formUrl` degrades to
 * `{base}/project/form/{id}`, which SaaS rejects with `Invalid alias`.
 *
 * Imported from '@formio/angular' rather than '@formio/js': the app's components come from the
 * former, and going through one package avoids setting these on a second copy of the SDK if the two
 * ever fail to dedupe.
 *
 * Guarded because the key is optional -- a tenant that has not been given a deployment keeps the
 * library default rather than inheriting another tenant's server.
 *
 * ORDER MATTERS: `setBaseUrl` assigns `projectUrl` only `if (!Formio.projectUrlSet)`, and
 * `setProjectUrl` is what sets that flag (`@formio/core/lib/sdk/Formio.js:1675-1708`) -- so base
 * first, then project, is the order that lands both values. Swapping them silently drops one.
 */
if (environment.formio?.baseUrl && environment.formio?.projectUrl) {
  Formio.setBaseUrl(environment.formio.baseUrl);
  Formio.setProjectUrl(environment.formio.projectUrl);
}

platformBrowserDynamic().bootstrapModule(AppModule, {
  ngZoneEventCoalescing: true,
})
  .catch(err => console.error(err));
